'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { EditProfileData } from "@/interfaces/api/profiles/api_request_types"
import { API_Data_Edit_Profile_Response } from "@/interfaces/api/profiles/api_response_types"
import { editProfile } from "../requests/profiles"

export const useEditProfile = () => useMutation<API_Data_Edit_Profile_Response, API_Error, { profileId: string, payload: EditProfileData }>({
    retry: false,
    mutationFn: editProfile
})